import { mapListToRecords, normalizeList } from '@sophocles/entities/entityUtils';
import {
  WeeklySolarReport,
  weeklySolarReportSchema,
} from '@sophocles/entities/WeeklySolarReport/weeklySolarReportRecord';
import apiClient from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';
import { endOfDay, format, parseISO, startOfDay } from 'date-fns';
import { fromJS } from 'immutable';
import { normalize } from 'normalizr';

/* Receive Actions */
export const RECEIVE_WEEKLY_SOLAR_REPORTS = 'RECEIVE_WEEKLY_SOLAR_REPORTS';
function receiveWeeklySolarReports(json) {
  return {
    type: RECEIVE_WEEKLY_SOLAR_REPORTS,
    weeklySolarReports: mapListToRecords(json, WeeklySolarReport),
  };
}

/* Request Actions */
// starter request
export const REQUEST_WEEKLY_SOLAR_REPORT = 'REQUEST_WEEKLY_SOLAR_REPORT';
function requestWeeklySolarReport(weeklySolarReport_id) {
  return {
    type: REQUEST_WEEKLY_SOLAR_REPORT,
    weeklySolarReport_id,
  };
}

export const REQUEST_WEEKLY_SOLAR_REPORTS_FOR_SITE_WITH_RANGE = 'REQUEST_WEEKLY_SOLAR_REPORTS_FOR_SITE_WITH_RANGE';
function requestWeeklySolarReportsForSiteWithRange(site_id, from, to) {
  return {
    type: REQUEST_WEEKLY_SOLAR_REPORTS_FOR_SITE_WITH_RANGE,
    site_id,
    from,
    to,
  };
}

/* Fetch Actions */
// starter fetch

export function fetchWeeklySolarReport(weeklySolarReport_id) {
  return dispatch => {
    dispatch(requestWeeklySolarReport(weeklySolarReport_id));
    return apiClient
      .get(`/weeklysolarreports/${weeklySolarReport_id}/`)
      .then(checkHttpStatus)
      .then(response => normalizeList(response.data, 'weeklySolarReports', weeklySolarReportSchema))
      .then(json => dispatch(receiveWeeklySolarReports(json.entities.weeklySolarReports)))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_WEEKLY_SOLAR_REPORT)));
  };
}

export function fetchWeeklySolarReportsForSiteWithRange(site_id, from, to) {
  const fromTS = startOfDay(parseISO(from));
  const toTS = endOfDay(parseISO(to));
  return dispatch => {
    dispatch(requestWeeklySolarReportsForSiteWithRange(site_id, fromTS, toTS));
    return apiClient
      .get(
        `/weeklysolarreports/?site=${site_id}&week_end_date__gte=${format(
          fromTS,
          'yyyy-MM-dd',
        )}&week_end_date__lte=${format(toTS, 'yyyy-MM-dd')}`,
      )
      .then(checkHttpStatus)
      .then(response => normalizeList(response.data.results, 'weeklySolarReports', weeklySolarReportSchema))
      .then(json => dispatch(receiveWeeklySolarReports(json.entities.weeklySolarReports)))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_WEEKLY_SOLAR_REPORTS_FOR_SITE_WITH_RANGE)));
  };
}

// expecting a siteGroup id and a moment object for endDate
export function fetchWeeklySolarReportsForSiteGroupWithEndDate(siteGroup_id, endDate) {
  return dispatch => {
    dispatch({ type: 'REQUEST_WEEKLY_SOLAR_REPORTS_FOR_SITE_GROUP_WITH_RANGE', siteGroup_id, endDate });
    return apiClient
      .get(
        `/weeklysolarreports/?limit=1000&site__site_groups=${siteGroup_id}&week_end_date=${endDate}&exclude_wallscape=True`,
      )
      .then(checkHttpStatus)
      .then(response => fromJS(response.data.results))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_WEEKLY_SOLAR_REPORT)));
  };
}

/* Edit Actions */
export const EDIT_WEEKLY_SOLAR_REPORT = 'EDIT_WEEKLY_SOLAR_REPORT';
export function editWeeklySolarReport(weeklySolarReport_id) {
  return {
    type: EDIT_WEEKLY_SOLAR_REPORT,
    weeklySolarReport: weeklySolarReport_id,
  };
}

export function patchWeeklySolarReport(weeklySolarReport_id, values) {
  return dispatch => {
    dispatch(editWeeklySolarReport(weeklySolarReport_id));
    return apiClient
      .patch(`/weeklysolarreports/${weeklySolarReport_id}/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, weeklySolarReportSchema))
      .then(json => dispatch(receiveWeeklySolarReports(json.entities.weeklySolarReports)))
      .catch(error => dispatch(genericErrorAction(error, EDIT_WEEKLY_SOLAR_REPORT)));
  };
}

/* Create Actions */
export const CREATE_WEEKLY_SOLAR_REPORT = 'CREATE_WEEKLY_SOLAR_REPORT';
function sayCreateWeeklySolarReport(values) {
  return {
    type: CREATE_WEEKLY_SOLAR_REPORT,
    values: values,
  };
}

export function createWeeklySolarReport(values) {
  return dispatch => {
    dispatch(sayCreateWeeklySolarReport(values));
    return apiClient
      .post(`/weeklysolarreports/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, weeklySolarReportSchema))
      .then(json => dispatch(receiveWeeklySolarReports(json.entities.weeklySolarReports)))
      .catch(error => dispatch(genericErrorAction(error, CREATE_WEEKLY_SOLAR_REPORT)));
  };
}

/* Delete Actions */
export const DELETE_WEEKLY_SOLAR_REPORT = 'DELETE_WEEKLY_SOLAR_REPORT';
function sayDeleteWeeklySolarReport(weeklySolarReport_id) {
  return {
    type: DELETE_WEEKLY_SOLAR_REPORT,
    weeklySolarReport: weeklySolarReport_id,
  };
}

export function deleteWeeklySolarReport(weeklySolarReport_id) {
  return dispatch =>
    apiClient
      .delete(`/weeklysolarreports/${weeklySolarReport_id}/`)
      .then(checkHttpStatus)
      .then(r => dispatch(sayDeleteWeeklySolarReport(weeklySolarReport_id)))
      .catch(error => dispatch(genericErrorAction(error, DELETE_WEEKLY_SOLAR_REPORT)));
}
